import React from 'react';

function Support() {

  const supportChannels = [
    {
      title: "WhatsApp 24/7",
      description: "Soporte instantáneo para urgencias",
      icon: "fab fa-whatsapp",
      color: "success",
      action: "https://wa.me/595211234567",
      isExternal: true
    },
    {
      title: "Email",
      description: "Respuesta en hasta 24 horas",
      icon: "fas fa-envelope",
      color: "primary",
      action: "mailto:contacto@herramientastayrun.com.py",
      isExternal: true
    },
    {
      title: "Teléfono",
      description: "Lunes a Viernes, 9h a 18h",
      icon: "fas fa-phone",
      color: "info",
      action: "tel:+595211234567",
      isExternal: true
    }
  ];

  return (
    <div style={{
      backgroundColor: '#f8f9fa',
      minHeight: '100vh',
      padding: '40px 0'
    }}>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-lg-10">
            <div className="text-center mb-5">
              <h1 className="display-5 fw-bold text-dark mb-3">
                Soporte al Cliente
              </h1>
              <p className="lead text-muted">
                ¡Estamos aquí para ayudar! Elige la mejor forma de contactarnos.
              </p>
            </div>

            {/* Support Channels */}
            <div className="row g-4 mb-5">
              {supportChannels.map((channel, index) => (
                <div key={index} className="col-md-6 col-lg-4">
                  <div className={`card border-0 shadow-sm h-100 bg-${channel.color} text-white`}>
                    <div className="card-body text-center p-4">
                      <div className="mb-3">
                        <i className={`${channel.icon} fa-3x`}></i>
                      </div>
                      <h5 className="fw-bold mb-2">{channel.title}</h5>
                      <p className="mb-3 small opacity-75">{channel.description}</p>
                      {channel.isExternal ? (
                        <a 
                          href={channel.action} 
                          target="_blank" 
                          rel="noopener noreferrer"
                          className="btn btn-light btn-sm w-100"
                        >
                          Acceder
                        </a>
                      ) : (
                        <button className="btn btn-light btn-sm w-100">
                          Iniciar Chat
                        </button>
                      )}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Contact Information */}
            <div className="row g-5">
              <div className="col-lg-8">
                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4">
                    <h4 className="fw-bold text-dark mb-4">
                      Información de Contacto
                    </h4>
                    
                    <div className="row g-4">
                      <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                          <div className="bg-success text-white rounded-circle p-3 me-3">
                            <i className="fab fa-whatsapp fa-lg"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1">WhatsApp 24/7</h6>
                            <p className="mb-0 text-muted">+595 21 123-4567</p>
                                                         <a href="https://wa.me/595211234567" target="_blank" rel="noopener noreferrer" className="text-success small">
                               Enviar mensaje
                             </a>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                          <div className="bg-primary text-white rounded-circle p-3 me-3">
                            <i className="fas fa-envelope fa-lg"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1">Email</h6>
                            <p className="mb-0 text-muted">contacto@herramientastayrun.com.py</p>
                                                         <a href="mailto:contacto@herramientastayrun.com.py" className="text-primary small">
                               Enviar email
                             </a>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                          <div className="bg-info text-white rounded-circle p-3 me-3">
                            <i className="fas fa-phone fa-lg"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1">Teléfono</h6>
                            <p className="mb-0 text-muted">+595 21 123-4567</p>
                                                         <a href="tel:+595211234567" className="text-info small">
                               Llamar ahora
                             </a>
                          </div>
                        </div>
                      </div>
                      
                      <div className="col-md-6">
                        <div className="d-flex align-items-center mb-3">
                          <div className="bg-warning text-white rounded-circle p-3 me-3">
                            <i className="fas fa-clock fa-lg"></i>
                          </div>
                          <div>
                            <h6 className="fw-bold mb-1">Horario de Atención</h6>
                            <p className="mb-0 text-muted">Lunes a Viernes: 9h a 18h</p>
                            <p className="mb-0 text-muted">Sábado: 9h a 14h</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Quick Help */}
              <div className="col-lg-4">
                <div className="card border-0 shadow-sm mb-4">
                  <div className="card-body p-4">
                                         <h5 className="fw-bold text-dark mb-3">
                       Ayuda Rápida
                     </h5>
                    <div className="d-grid gap-2">
                                               <a href="/faq/" className="btn btn-outline-primary">
                           <i className="fas fa-search me-2"></i>
                           Ver FAQ
                         </a>
                         <a href="/contact/" className="btn btn-outline-success">
                           <i className="fas fa-envelope me-2"></i>
                           Contacto
                         </a>
                         <a href="/about/" className="btn btn-outline-info">
                           <i className="fas fa-info-circle me-2"></i>
                           Sobre Nosotros
                         </a>
                    </div>
                  </div>
                </div>

                <div className="card border-0 shadow-sm">
                  <div className="card-body p-4">
                                         <h5 className="fw-bold text-dark mb-3">
                       Consejos Útiles
                     </h5>
                                         <ul className="small text-muted">
                       <li>Ten tu número de pedido a mano</li>
                       <li>Describe el problema con detalles</li>
                       <li>Usa WhatsApp para casos urgentes</li>
                       <li>Incluye fotos si es necesario</li>
                     </ul>
                  </div>
                </div>
              </div>
            </div>

            {/* Emergency Contact */}
            <div className="mt-5">
              <div className="card border-danger border-2">
                <div className="card-body text-center p-4">
                                     <h4 className="fw-bold text-danger mb-3">
                     Casos Urgentes
                   </h4>
                   <p className="mb-3">
                     Para problemas críticos que necesitan atención inmediata, usa nuestro WhatsApp 24/7.
                   </p>
                  <a href="https://wa.me/595211234567" target="_blank" rel="noopener noreferrer" className="btn btn-danger btn-lg">
                                         <i className="fab fa-whatsapp me-2"></i>
                     WhatsApp Urgente
                   </a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Support;
